import isArray from 'lodash-es/isArray';
import isFunction from 'lodash-es/isFunction';
//converts the url path params to their value
const fromOldtoNewUrl = (path) => (url, key) => {
    const param = path[key];
    let pattern = new RegExp('\{' + key + '\}'); //eslint-disable-line
    if (typeof param == 'object' && !!param) {
        return url.replace(pattern, param.resource); //eslint-disable-line
    }
    else if (typeof param != 'object') {
        return url.replace(pattern, param); //eslint-disable-line
    }
    return url;
};
const modified = (config) => (client) => {
    if (!client) {
        throw new Error('axios instance must exist');
    }
    //add simple query string param translation
    client.interceptors.request.use((request) => {
        const config = request; //we know this is modified so we can cast it
        //condense previous params and query info from 
        request.params = { ...request.params, ...config?.query };
        return request;
    });
    //add url translation
    client.interceptors.request.use((request) => {
        const config = request; //we know this is modified so we can cast it
        //assign new url
        const url = Object.keys(config?.path || {}).reduce(fromOldtoNewUrl(config?.path || {}), config.url);
        request.url = url;
        return request;
    });
    //add interceptors
    if (!!config) {
        const configs = isArray(config) ? config : [config];
        configs.forEach((config) => {
            const { request, response, error } = isFunction(config) ? config() : config;
            if (!!request) {
                client.interceptors.request.use(request(client));
            } //TODO: fix to type infer intercepters from config
            if (!!response || !!error) {
                client.interceptors.response.use(response && response(client), error && error(client));
            }
        });
    }
    //return client
    const wrappedClient = {
        get: (config) => client.get(config.url, config),
        post: (config) => client.post(config.url, config.data, config),
        put: (config) => client.put(config.url, config.data, config),
        delete: (config) => client.delete(config.url, config)
    };
    return wrappedClient;
};
export default modified;
//# sourceMappingURL=index.js.map